import React from 'react'
import { motion } from "framer-motion";

export default function CallAction() {
  return (
    <section className="relative py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">

      {/* Background Gradient */}
      <div className="absolute inset-0 " />

      {/* Glow Effects */}
      {/* <div className="absolute w-72 h-72 bg-orange-400/30 blur-3xl rounded-full top-[-80px] left-[-80px] animate-pulse" />
      <div className="absolute w-72 h-72 bg-blue-400/30 blur-3xl rounded-full bottom-[-80px] right-[-80px] animate-pulse" /> */}

      {/* Content */}
      <div className="relative max-w-5xl mx-auto text-center bg-gr rounded-[20px]">

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 sm:p-12 shadow-xl"
        >

          {/* Heading */}
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            Ready to Get Your Loan Approved?
          </h2>

          {/* Description */}
          <p className="text-gray-200 text-sm sm:text-base mb-8 max-w-2xl mx-auto">
            Apply in minutes and get instant approval with our fast, secure, and
            fully digital process. No paperwork. No delays.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4">

            <button className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-full font-medium transition-all hover:scale-105">
              Apply Now
            </button>

            <button className="bg-white/20 border border-white/30 text-white px-6 py-3 rounded-full hover:bg-white/30 transition-all">
              Learn More
            </button>

          </div>

        </motion.div>
      </div>
    </section>
  )
}
